export default "__VITE_ASSET__DKqwM4Kd__"